const ensureTrackerQueue = () => {
  if (typeof window === 'undefined') return null;
  window._czc = window._czc || [];
  return window._czc;
};

const trackEvent = (category, action, label) => {
  const queue = ensureTrackerQueue();
  if (!queue) return;
  queue.push(['_trackEvent', category, action, label]);
};

export const trackUserLoginEnterSystem = () => {
  trackEvent('A0001-用户登录进入系统', 'login', 'user_login_enter_system');
};

export const trackUserEnterHomePage = () => {
  trackEvent('A0002-进入系统页面', 'view', 'user_enter_home_page');
};

export const trackWorkorderSearch = () => {
  trackEvent('A0003-工单查询', 'search', 'workorder_search');
};
